'use client';

// Assets
import IX from '@public/svg/i-x';
import { SlMagnifier } from 'react-icons/sl';

// Hooks
import useWindowsSize from '@src/hooks/useWindowSize';

const Search = ({
  displaySearch,
  handleChangeSearch,
  setShowSearch,
  resetSearch,
  placeholder = 'cari "Setiabudi" atau "Jakarta Selatan"',
}) => {
  const { dd2XL } = useWindowsSize();

  return (
    <div className="flex items-center gap-2 h-[48px] px-[12px] bg-white w-full">
      <input
        type="text"
        className="w-full h-full bg-[#ffffff] text-[17px] leading-[23.8px] tracking-[-0.17px] font-satoshi placeholder:text-[#686A68]"
        placeholder={placeholder}
        value={displaySearch}
        onChange={handleChangeSearch}
        onFocus={() => !dd2XL && setShowSearch(true)}
        onClick={() => dd2XL && setShowSearch(true)}
      />

      {displaySearch.length > 0 && (
        <button
          className="p-1 flex items-center justify-center rounded-[16px] bg-[#f5f5f5]"
          onClick={resetSearch}
        >
          <IX width={16} height={16} color="#686A68" />
        </button>
      )}

      <div>
        <SlMagnifier className="text-[24px]" />
      </div>
    </div>
  );
};

export default Search;
